//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { IPinterestFormState } from '@universal-scheduling/models/SchedulerPostDetailsModels';

export const DEFAULT_PINTEREST_POST_DETAILS_STATE: IPinterestFormState = {
  postType: UniversalPostType.PinterestOrganicPin,
  postNow: false,
};

export const MAX_PIN_DESCRIPTION_LENGTH = 500;

export const PinterestPostDetailsFormFieldErrorText = {
  TextTooLong: 'Please enter 500 characters or less.',
  BoardRequired: 'Please select a board.',
} as const;

export const MAX_BOARD_PAGES = 500;
